import {ToggleSwitch, ToggleType} from "@twigsby/frontend-framework";
import {useForwardingBatchProvider} from "../../../Providers/ForwardingBatchProvider";
import {RenderBatchSectionType} from "../../../Types/ForwardingBatchTypes";

const BatchLegal = (props: RenderBatchSectionType) => {
    const { currentBatchData} = useForwardingBatchProvider();

    if(props.complete) return null;

    return (
        <div>
            <h5 className={'mb-xs'}>{props.complete ? props.section.name : `Step ${props.sectionIndex}: ${props.section.name}`}</h5>

            <p>By forwarding these items, you state that:</p>

            <ul>
                <li>You have accurately answered the above questions.</li>
                <li>You understand that failure to complete accurately can result in the disposal of the goods/package
                    and potential legal action from the relevant authorities.
                </li>
                <li>You understand that in the event of any incident resulting from no or inaccurate disclosure, you
                    will accept the liability of any legal action or claim.
                </li>
                <li>You agree to indemnify UK Postbox and UK Postbox employees from any liability, claim or action.</li>
            </ul>

            <ToggleSwitch
                name={'agreeToLegal'}
                label={'I understand and agree with the above statements.'}
                type={ToggleType.Checkbox}
                disabled={props.readOnly}
                defaultChecked={props.readOnly || currentBatchData?.dateSigned !== null}
            />
        </div>
    )
}

export {BatchLegal}
